var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 6770",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.791,
    height: 14.579,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 200",
    d: "M11.227 2.805l-.925 10.588H3.488L2.559 2.801l-1.178.1.946 10.792a1 1 0 00.982.887h7.171a1 1 0 00.983-.894l.946-10.777z",
    fill: "#fc035d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 201",
    d: "M9.062 0H4.728a.986.986 0 00-.985.985v1.872h1.182V1.182h3.94v1.675h1.181V.985A.986.986 0 009.062 0z",
    fill: "#fc035d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M13.2 2.266H.591a.591.591 0 100 1.182H13.2a.591.591 0 100-1.182z",
    fill: "#fc035d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmDelete);
export default __webpack_public_path__ + "static/media/am-delete.ef2d670060dabbc1c2e363a188749486.svg";
export { ForwardRef as ReactComponent };